/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum ExecutionJobType {
    CLIENT_CONFIG_SYNC = 'CLIENT_CONFIG_SYNC',
    BATCH_CHANGE_CLIENT_CONTACT_ACCOUNT_STATE = 'BATCH_CHANGE_CLIENT_CONTACT_ACCOUNT_STATE',
}
